// Page publique du client final : /p/:jeton (lien secret au dos de sa carte Wallet)
// Accepter / refuser les offres, supprimer sa carte et ses données (RGPD).
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from './supabase'
import { CORAL, CHARBON, SABLE, Logo, LiensLegaux } from './actions'

async function appeler(body) {
  const { data, error } = await supabase.functions.invoke('preferences-client', { body })
  if (error) {
    const detail = await error.context?.json?.().catch(() => null)
    throw new Error(detail?.error || 'Erreur réseau, réessaie')
  }
  if (data?.error) throw new Error(data.error)
  return data
}

export default function Preferences() {
  const { jeton } = useParams()
  const [infos, setInfos] = useState(null)
  const [erreur, setErreur] = useState('')
  const [message, setMessage] = useState('')
  const [confirmer, setConfirmer] = useState(false)
  const [supprime, setSupprime] = useState(false)
  const [occupe, setOccupe] = useState(false)

  useEffect(() => {
    appeler({ action: 'info', jeton }).then(setInfos).catch(e => setErreur(e.message))
  }, [jeton])

  async function changerOffres(offres) {
    setOccupe(true); setErreur(''); setMessage('')
    try {
      await appeler({ action: 'offres', jeton, offres })
      setInfos({ ...infos, offres })
      setMessage(offres ? 'Tu recevras les offres de ce commerce.' : 'C\'est noté : plus aucune offre.')
    } catch (e) { setErreur(e.message) }
    setOccupe(false)
  }

  async function supprimer() {
    setOccupe(true); setErreur('')
    try {
      await appeler({ action: 'supprimer', jeton })
      setSupprime(true)
    } catch (e) { setErreur(e.message) }
    setOccupe(false)
  }

  const page = {
    minHeight: '100vh', background: SABLE, fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2rem 1rem',
  }
  const bloc = { width: '100%', maxWidth: 400, background: '#fff', borderRadius: 16, padding: '1.5rem', border: '1px solid #e8e0d8', boxSizing: 'border-box' }
  const bouton = (fond, texte = '#fff') => ({
    width: '100%', background: fond, color: texte, border: fond === '#fff' ? '1px solid #e8e0d8' : 'none',
    borderRadius: 12, padding: '13px', fontSize: 15, fontWeight: 700, cursor: occupe ? 'wait' : 'pointer', marginTop: 10,
  })

  let contenu
  if (supprime) {
    contenu = (
      <div style={{ ...bloc, textAlign: 'center' }}>
        <div style={{ fontSize: 36 }}>👋</div>
        <div style={{ fontSize: 17, fontWeight: 700, color: CHARBON, margin: '8px 0' }}>Carte supprimée</div>
        <div style={{ fontSize: 14, color: '#666', lineHeight: 1.5 }}>
          Tes données ont été effacées. La carte apparaît désormais comme inactive dans ton Wallet :
          tu peux la retirer de ton téléphone.
        </div>
      </div>
    )
  } else if (erreur && !infos) {
    contenu = <div style={{ ...bloc, textAlign: 'center', color: '#888' }}>{erreur}</div>
  } else if (!infos) {
    contenu = <div style={{ color: '#bbb', marginTop: '3rem' }}>Chargement…</div>
  } else {
    contenu = (
      <div style={bloc}>
        <div style={{ height: 6, borderRadius: 3, background: infos.couleur || CHARBON, marginBottom: 16 }} />
        <div style={{ fontSize: 13, color: '#999' }}>Ta carte chez</div>
        <div style={{ fontSize: 22, fontWeight: 800, color: CHARBON }}>{infos.commerce}</div>
        <div style={{ fontSize: 14, color: '#666', margin: '6px 0 20px' }}>
          {infos.prenom} · {infos.tampons}/{infos.objectif} tampons
        </div>

        <div style={{ fontSize: 15, fontWeight: 700, color: CHARBON }}>Offres du commerce</div>
        <div style={{ fontSize: 14, color: '#666', margin: '4px 0 4px' }}>
          {infos.offres ? 'Tu acceptes de recevoir ses offres.' : 'Tu ne reçois pas ses offres.'}
        </div>
        {infos.offres
          ? <button onClick={() => changerOffres(false)} disabled={occupe} style={bouton(CHARBON)}>Ne plus recevoir d'offres</button>
          : <button onClick={() => changerOffres(true)} disabled={occupe} style={bouton('#fff', CHARBON)}>Recevoir les offres</button>}
        {message && <div style={{ fontSize: 13, color: '#3B6D11', marginTop: 10 }}>✅ {message}</div>}

        <div style={{ borderTop: '1px solid #f0ece8', margin: '22px 0 16px' }} />

        <div style={{ fontSize: 15, fontWeight: 700, color: CHARBON }}>Supprimer ma carte</div>
        <div style={{ fontSize: 14, color: '#666', margin: '4px 0 4px', lineHeight: 1.5 }}>
          Efface ton prénom, ton téléphone et l'historique de tes passages. Tes tampons seront perdus.
        </div>
        {confirmer ? (
          <>
            <button onClick={supprimer} disabled={occupe} style={bouton(CORAL)}>{occupe ? 'Suppression…' : 'Oui, tout supprimer'}</button>
            <button onClick={() => setConfirmer(false)} disabled={occupe} style={bouton('#fff', '#888')}>Annuler</button>
          </>
        ) : (
          <button onClick={() => setConfirmer(true)} style={bouton('#fff', CORAL)}>Supprimer ma carte et mes données</button>
        )}
        {erreur && <div style={{ color: CORAL, fontSize: 13, marginTop: 10 }}>{erreur}</div>}
      </div>
    )
  }

  return (
    <div style={page}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1.5rem' }}>
        <Logo size={32} />
        <div style={{ fontSize: 17, fontWeight: 800, color: CHARBON, letterSpacing: -1 }}>jeebi</div>
      </div>
      {contenu}
      <LiensLegaux style={{ marginTop: '1.5rem' }} />
    </div>
  )
}
